import * as React from 'react';

export const uyFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_268)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#F1F5F9'
            />
            <mask
                id='mask0_1_268'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_268)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M13.3333 4H28V6.66667H13.3333V4ZM13.3333 9.33333H28V12H13.3333V9.33333ZM0 14.6667H28V17.3333H0V14.6667Z'
                    fill='#0035A9'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M9.17332 9.17334C8.86666 10.8333 8.15999 12 7.33332 12C6.50666 12 5.79999 10.8347 5.49332 9.17334C3.83332 8.86667 2.66666 8.16 2.66666 7.33334C2.66666 6.50667 3.83199 5.8 5.49332 5.49334C5.79999 3.83334 6.50666 2.66667 7.33332 2.66667C8.15999 2.66667 8.86666 3.832 9.17332 5.49334C10.8333 5.8 12 6.50667 12 7.33334C12 8.16 10.8347 8.86667 9.17332 9.17334Z'
                    fill='#D4AF2C'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M8.24932 8.24934C8.16399 10.3867 7.78666 12 7.33332 12C6.87999 12 6.50266 10.3867 6.41732 8.24934C4.27999 8.164 2.66666 7.78667 2.66666 7.33334C2.66666 6.88 4.27999 6.50267 6.41732 6.41734C6.50266 4.28001 6.87999 2.66667 7.33332 2.66667C7.78666 2.66667 8.16399 4.28001 8.24932 6.41734C10.3867 6.50267 12 6.88 12 7.33334C12 7.78667 10.3867 8.164 8.24932 8.24934Z'
                    fill='#FFDA2C'
                />
                <path
                    d='M7.33334 9.33333C8.43791 9.33333 9.33334 8.4379 9.33334 7.33333C9.33334 6.22876 8.43791 5.33333 7.33334 5.33333C6.22877 5.33333 5.33334 6.22876 5.33334 7.33333C5.33334 8.4379 6.22877 9.33333 7.33334 9.33333Z'
                    fill='#FFDA2C'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_268'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
